module.exports = __webpack_public_path__ + "static/media/img1.99283153.jpeg";